import { Patient, PatientDetailsConfig, PatientDetailsConfigElement } from '../../models/patient';

const keyMap: Record<keyof PatientDetailsConfig, keyof Patient> = {
  dob: 'dateOfBirth',
  address: 'address',
};

export const isAnyRequiredFieldMissing = (patient: Patient | null) => {
  if (!patient || !patient.patientDetailsConfig) {
    return false;
  }

  return (
    Object.entries(patient.patientDetailsConfig) as [
      keyof PatientDetailsConfig,
      PatientDetailsConfigElement
    ][]
  ).some(([key, field]) => field.required && !patient[keyMap[key]]);
};

export const isAnyFieldVisible = (patient: Patient | null) => {
  if (!patient || !patient.patientDetailsConfig) {
    return false;
  }

  return (
    Object.values(patient.patientDetailsConfig) as PatientDetailsConfigElement[]
  ).some((field) => field.visible);
};